import { render, staticRenderFns } from "./ProjectUserModal.vue?vue&type=template&id=bfc85ac6&scoped=true"
import script from "./ProjectUserModal.vue?vue&type=script&lang=js"
export * from "./ProjectUserModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectUserModal.vue?vue&type=style&index=0&id=bfc85ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc85ac6",
  null
  
)

export default component.exports